import React, { useState, useEffect } from "react";
import Button from "../common/Button/Button";
import { ReactComponent as Title } from "../images/title.svg";
import { ReactComponent as BurgerIcon } from "../images/burger-menu.svg";

function Header() {
  const [top, setTop] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false); 
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 820;
  const shouldIconBeSmall = width <= 1536;

  useEffect(() => {
    const scrollHandler = () => {
      window.pageYOffset > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [top]);
  const closeNav = () => setIsNavOpen(false);

  return (
    <header
      className={`fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ${
        !top && "bg-white backdrop-blur-sm shadow-lg"
      }`}
    >
      <div className="mx-auto">
        <div className="flex items-center justify-between md:h-20 wrapper">
          <div
            className="flex flex-col items-center mt-2 "
            style={{ minHeight: shouldIconBeSmall ? 50 : 66 }}
          >
            <svg
              className="logo-icon"
              width="50"
              height="44"
              viewBox="0 0 75 66"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_467_17)">
                <path
                  d="M74.9824 43.162C74.8859 45.9646 74.3184 48.8052 73.1745 51.3533C66.3845 66.5072 40.0232 65.4423 32.9904 65.1585C23.0731 64.7548 8.03038 64.1463 2.43105 53.7961C1.56219 52.19 0.927365 50.3616 0.529502 48.4249C0.359826 47.5853 0.231106 46.7282 0.149193 45.8593C-0.157981 42.7261 0.119938 39.4467 0.977098 36.4744C1.02391 36.3106 1.07364 36.1468 1.12337 35.9859C1.60022 34.4529 2.23212 33.0107 3.02492 31.7147C7.378 24.6088 10.1104 21.9729 10.1104 21.9729C11.5848 20.5482 14.0042 18.4916 14.6244 15.218C14.7326 14.6359 14.9608 13.3721 14.6302 11.8391C14.13 9.49876 12.9217 9.2501 12.3805 7.32807C11.6989 4.91164 12.559 1.59417 14.6448 0.57026C16.0315 -0.111372 17.5762 0.421062 18.0238 0.576111C21.2447 1.67901 21.4378 4.53133 23.6523 5.09009C24.1965 5.22759 24.6587 5.16908 25.1063 4.98478C26.4257 4.43772 27.5959 2.74973 30.1556 1.47423C30.179 1.46838 30.1966 1.45667 30.2141 1.44497C30.4043 1.35721 30.6032 1.26652 30.808 1.17583C31.9168 0.701906 33.125 0.368403 34.3654 0.184099C36.9222 -0.202061 39.6429 0.0202737 42.0301 0.856955C43.0862 1.22556 44.0779 1.71411 44.9614 2.32554C47.6089 4.15102 47.685 6.18422 49.569 6.24858C52.0556 6.33049 52.8982 2.91355 56.8504 2.34016C57.5701 2.2407 59.0153 2.04762 60.2469 2.91063C61.2211 3.59226 62.0461 4.89994 61.9641 6.26613C61.8325 8.50703 59.3634 8.90489 58.5765 11.8947C58.24 13.1673 58.3863 14.2263 58.4594 14.7266C58.8105 17.0581 60.282 18.752 61.499 19.7818C62.1923 20.3756 62.8038 20.753 63.0729 20.9139C63.0729 20.9139 66.0715 23.1168 69.7283 27.8121C70.4889 28.7892 71.2788 29.8717 72.0745 31.0652C73.3617 33.0048 74.292 35.6436 74.725 38.5544C74.9473 40.0406 75.038 41.594 74.9824 43.162Z"
                  fill="#B09EE6"
                />
                <path
                  d="M74.9824 43.162C74.8859 45.9646 74.3184 48.8052 73.1745 51.3533C66.3845 66.5072 40.0232 65.4423 32.9904 65.1585C23.0731 64.7548 8.03038 64.1463 2.43105 53.7961C1.18773 51.4937 0.421262 48.735 0.149194 45.8593C-0.175532 42.5535 0.152119 39.0869 1.12337 35.9859C1.60022 34.4529 2.23212 33.0107 3.02492 31.7147C7.378 24.6088 10.1104 21.9729 10.1104 21.9729C11.5848 20.5482 14.0042 18.4916 14.6244 15.218C14.7326 14.6359 14.9608 13.3721 14.6302 11.8391C14.13 9.49876 12.9217 9.2501 12.3805 7.32807C11.6989 4.91164 12.559 1.59417 14.6448 0.57026C16.0315 -0.111372 17.5762 0.421062 18.0238 0.576111C21.2447 1.67901 21.4378 4.53133 23.6523 5.09009C24.1965 5.22759 24.6587 5.16908 25.1063 4.98478C26.4257 4.43772 27.5959 2.74973 30.1556 1.47423C30.179 1.46838 30.1966 1.45667 30.2141 1.44497C30.4043 1.35721 30.6032 1.26652 30.808 1.17583C31.9168 0.701906 33.125 0.368403 34.3654 0.184099C36.9222 -0.202061 39.6429 0.0202737 42.0301 0.856955C31.7412 3.82337 24.2023 11.8304 22.6723 21.3703C22.6577 21.4668 22.6343 21.6043 22.6109 21.7769C21.7537 27.6542 23.1813 35.6377 28.2307 40.6783C35.2723 47.7053 46.2457 45.8856 47.5387 45.6516C58.4624 43.6711 62.6282 34.6957 68.8946 36.5827C72.0453 37.5305 73.9059 40.6783 74.9824 43.162Z"
                  fill="#6E4CD1"
                />
                <path
                  d="M74.9824 43.162C74.8859 45.9646 74.3183 48.8052 73.1745 51.3533C66.3845 66.5072 40.0232 65.4423 32.9904 65.1585C23.231 64.7636 8.38141 64.1551 2.43103 53.7961C-0.105347 49.3815 -0.201887 44.6247 0.146243 41.2634C21.7917 55.5338 45.5435 53.9101 55.73 41.8485C61.6482 34.8391 61.9671 25.5098 61.499 19.7817C62.1923 20.3756 62.8037 20.753 63.0729 20.9139C63.0729 20.9139 66.0715 23.1168 69.7283 27.8121C70.4889 28.7892 71.2788 29.8716 72.0745 31.0652C73.3617 33.0048 74.292 35.6436 74.725 38.5544C74.9473 40.0405 75.038 41.594 74.9824 43.162Z"
                  fill="#4931AD"
                />
              </g>
              <defs>
                <clipPath id="clip0_467_17">
                  <rect width="75" height="65.2875" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <Title className="logo-icon-title"/>
          </div>

          <nav className="flex flex-grow">
            {!isMobile ? (
              <ul className="flex flex-grow justify-end flex-wrap items-center nav-buttons">
                <a
                  href="#demo"
                  className="header-link hover:text-violet-600 px-3 py-3 flex items-center transition duration-150 ease-in-out"
                >
                  Demo
                </a>
                <a
                  href=""
                  className="header-link  hover:text-violet-600 px-3 py-3 flex items-center transition duration-150 ease-in-out"
                >
                  LightPaper
                </a>
                <a
                  href="#roadmap"
                  className="header-link  hover:text-violet-600 px-3 py-3 flex items-center transition duration-150 ease-in-out"
                >
                  Roadmap
                </a>
                <a
                  href="#community"
                  className="header-link  hover:text-violet-600 px-3 py-3 flex items-center transition duration-150 ease-in-out"
                >
                  Join us
                </a>
                <Button text="Sign up" className="mx-3 ml-8 2xl:ml-16" outlined />
              </ul>
            ) : (
              <div className="flex flex-grow justify-end items-center">
                <BurgerIcon onClick={() => setIsNavOpen((prev) => !prev)} />
                <div className={isNavOpen ? "showMenuNav" : "hideMenuNav"}>
                  <div
                    className="CROSS-ICON absolute top-0 right-0 px-8 py-8"
                    onClick={() => setIsNavOpen(false)} // change isNavOpen state to false to close the menu
                  >
                    <svg
                      className="h-8 w-8 text-neutral-800"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </div>
                  <ul className="MENU-LINK-MOBILE-OPEN flex flex-col items-center justify-between min-h-[250px]">
                    <a
                      href="#demo"
                      className="lg:text-xl 2xl:text-2xl font-medium text-neutral-800 hover:text-violet-600 px-5 py-3 flex items-center transition duration-150 ease-in-out"
                      onClick={closeNav}
                    >
                      Demo
                    </a>
                    <a
                      href="#roadmap"
                      className="lg:text-xl 2xl:text-2xl font-medium text-neutral-800 hover:text-violet-600 px-5 py-3 flex items-center transition duration-150 ease-in-out"
                      onClick={closeNav}
                    >
                      Roadmap
                    </a>
                    <a
                      href="#footer"
                      className="lg:text-xl 2xl:text-2xl font-medium text-neutral-800 hover:text-violet-600 px-5 py-3 flex items-center transition duration-150 ease-in-out"
                      onClick={closeNav}
                    >
                      Join us
                    </a>
                  </ul>
                </div>
              </div>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
